import { Tooltip } from "antd";
import QuestionIcon from "@/assets/question.svg?react";

export function Hint({ title }: { title: string }) {
  return (
    <Tooltip title={title}>
      <span className="inline-flex cursor-help">
        <QuestionIcon className="pointer-events-none text-base" />
      </span>
    </Tooltip>
  );
}
